import PropTypes from "prop-types";
import React from 'react';
import { Tabs } from 'antd';
import { SelectTabsContainer } from './styles';

function SelectSchedule(props) {
  const { config, handleClick, activeTab } = props;

  function renderTabLabel(label) {
    return (
      label
    );
  }
  return (
    <SelectTabsContainer>
      <Tabs
        type="card"
        onChange={handleClick}
        tabBarExtraContent={renderTabLabel(config.extraContent)}
        defaultActiveKey="oneTime"
        activeKey={activeTab}
      >
        {config.tabConfig.map(tab => (
          <Tabs.TabPane tab={tab.title} key={tab.key}>
            {tab.content}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </SelectTabsContainer>
  );
}

SelectSchedule.propTypes = {
  activeTab: PropTypes.any,
  config: PropTypes.array,
  handleClick: PropTypes.func
}

export default SelectSchedule;
